import { Link, Text } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';

export const TermsSignupMessage = (): JSX.Element => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;

  return (
    <Text fontSize={14} mb={-4} mt={3}>
      <Trans
        components={{
          url: (
            <Link
              color="brand.red.light"
              href={`/files/legal/general_terms_and_conditions_${currentLanguage}.pdf`}
              target="_blank"
            />
          ),
        }}
        i18nKey="SIGNUP.SIGNUP_POLICY"
      />
    </Text>
  );
};
